<template>
    <ul v-if="!selectedLocation" class="location-search-container__results--list">
        <template v-if="filteredLocations.length > 0">
            <li v-for="(location) in filteredLocations" :key="location.id" class="location-search-container__results--list-item">
                <results-list-item
                :location="location"
                :selectLocationClick="selectLocationClickFn"
                ></results-list-item>
            </li>
        </template>
        <li v-if="!filteredLocations.length && !isInitializing && !isLoading" class="no-results px-2">
            <h5>
                {{text('noResults')}}
            </h5>
            <div class="noresultstarget"></div>
        </li>
        <li v-if="!filteredLocations.length && (isInitializing || isLoading)" class="loading-results px-2">
            <h5>Loading...</h5>
        </li>
    </ul>
</template>

<script>
import { locText } from "../../../utils/useText";
import { mapActions } from "vuex";
import EventBus from "../functions/eventBus";
import ResultsListItem from "./ResultsListItem.vue";

export default {
    created() {
        EventBus.on("scrollToTop", () => {
            this.scrollToTop();
        });
    },
    data() {
        return{
        }
    },
    mounted() {
        // if(this.$mq == 'desktop') {
        //     this.scrollToTop();
        // }
    },
    components: {
        "results-list-item": ResultsListItem
    },
    computed: {
        selectedLocation: {
            get() {
                return this.$store.getters.selectedLocation;
            },
            set(value) {
                this.updateSelectedLocation(value);
            }
        },
        filteredLocations: {
            get() {
                return this.$store.getters.filteredLocations;
            }
        },
        isInitializing: {
            get() {
                return this.$store.getters.isInitializing;
            }
        },
        isLoading: {
            get() {
                return this.$store.getters.isLoading;
            }
        },
        userSearch: {
            get() {
                return this.$store.getters.userSearch;
            }
        }
    },
    methods: {
        ...mapActions(["updateSelectedLocation"]),

        scrollToTop() {
            var target = document.getElementsByClassName("sidebar-wrapper")[0];
            scrollTo(target, 0, 300);
        },
        scrollForNoResults(){   
            if(this.$mq !== 'desktop') {
                setTimeout(()=> {
                },0);
            }
        },
        scrollToTopMobile(){
            var target = document.getElementsByClassName("results-list-container")[0];
            scrollTo(target, int, 300);
        },
        selectLocationClickFn(location) {
              if (typeof HERO_analytics_data_layer != "undefined") {
                var analytics = HERO_analytics_data_layer;
                var event = { 
                    event: "search__click",
                    search__type: "location-search",
                    search__term: this.userSearch.term,
                    search__resultText: location.name,
                    search__resultClickMetric : 1
                };
                analytics.pushEventAndData(event);

                var locationVuePageData = {
                    "event": "page_view",
                    "page_view__site": $("#site").val(),
                    "page_view__siteSection1": "locations",
                    "page_view__pageType": $("#pageType").val(),
                    "page_view__pageName": "simmons-bank|locations|" + location.name,

                };
                HERO_analytics_data_layer.pushData(locationVuePageData);
              }

            this.selectedLocation = location;
            //this.$router.push('test');
            //window.history.pushState({"pageTitle": location.name, "location" : location}, "", location.locationUrl);            
            this.scrollToTop();
        }
    },
    mixins: [locText],
    watch: {
        filteredLocations(newValue) {
            if (typeof HERO_analytics_data_layer != "undefined") {
              var analytics = HERO_analytics_data_layer;
              var event = { 
                event: "search",
                search__type: "location-search",
                search__term: this.userSearch.term,
                search__resultsNumber: newValue && newValue.length
              };
              analytics.pushEventAndData(event);              
            }
            if(!newValue.length && !this.isLoading){
                this.scrollForNoResults();
            } else {
                setTimeout(()=> {  
                    EventBus.scrollToTopMobile();
                },600);
            }
        }
    }
}
</script>
